import { render } from "./bidangPemerintahan.vue?vue&type=template&id=90653172"
import script from "./bidangPemerintahan.vue?vue&type=script&lang=js"
export * from "./bidangPemerintahan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__